import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import { NotificationsNew } from '../notifications/NotificationsNew';
import { getTrackingAttributes, TRACKING_CATEGORIES } from '../../configuration/setup/googleAnalytics';
import { isVehicleMode } from '../../utils/isVehicleMode';

const AppLayout = () => {
    // The dedicated route will be needed in any case for the Livemonitor to filter notifications by vehicle id.
    // Note that the flag is also used to apply different styling when being embedded in the Livemonitor as well
    // as showing different empty states.
    const showVehicleNotifications = isVehicleMode();

    return (
        <ApplicationLayout
            className={`PlatformNotifications bg-white ${showVehicleNotifications ? 'min-height-200' : ''}`}
            data-testid='platform-notifications'
            {...getTrackingAttributes({
                trigger: 'visibility',
                category: TRACKING_CATEGORIES.NAVIGATION,
                label: 'application loaded',
                action: `application loaded in ${showVehicleNotifications ? 'Livemonitor asset sidebar' : 'header'}`,
            })}
        >
            <NotificationsNew isVehicleMode={showVehicleNotifications} />
        </ApplicationLayout>
    );
};

export default AppLayout;
